import React, { useEffect, useState } from "react";
import yellowalert from "src/assets/images/alert-icon-yellow.png";
import closeic from "src/assets/images/close-ic.png";
import ClearSingleCartProductFromCart from "../ClearSingleCartProductFromCart";
import QuantityPickerForUpdateCart from "../../../component/custom/QuantityPickerForUpdateCart";
import QuantityScheduler from "./QuantityScheduler";
import DisplayQtyMinQtyMult from "../../../component/custom/DisplayQtyMinQtyMult";
import { useAxiosIndicatorCheck } from "../../../store/hook/useAxiosIndicatorCheck";
import { Tooltip } from "src/component/Global/Tooltip";
import System from "../../../helper/system";
import FadeInOut from "../../../component/Global/FadeInOut";
import CustomerPartNumberOptions from "../../../component/custom/CustomerPartNumberOptions";
import { isNumber } from "underscore";
import AxiosIndicatorRunTimeLoader from "../../../component/Global/AxiosIndicatorRunTimeLoader";
import ProductLegends from "src/pages/ProductListing/ProductLegends";
import { useCartStore } from "src/hooks/cart";
import noImage from "src/assets/images/noimage.png";
import Constants from "src/helper/Constants";
import { useProductStore } from "src/hooks/product";
import NavigateToProductDetail from "src/component/custom/NavigateToProductDetail";
import { useProductInventoryPriceStore } from "src/hooks/productInventoryPrice";
import Helper from "src/helper/Helper";
import ProductInventoryDisplay from "src/component/custom/ProductInventoryDisplay";
import { InputWithDebounce } from "src/component/custom/InputWithDebounce";
import { Beacon } from "src/component/Global/Beacon";
import { useSystem } from "src/hooks/system";
import HelperAnalyticsEvent from "src/support/HelperAnalyticsEvent";
import liveAuth from "src/helper/liveAuth";

const CartList = () => {
  const [__check] = useAxiosIndicatorCheck();
  const [{ CART_DATA, CART_LOADER_DATA_OBJECT }, { update_To_Cart_Server, backorder_not_available }, { }] = useCartStore();
  const [firstServerCall, setFirstServerCall] = useState(true);
  const [isLoader, setIsLoader] = useState(false);
  const [isOpenedBackOrderPopup, setIsOpenedBackOrderPopup] = useState(false);
  const [{ productList }, { }, { }] = useProductStore();
  const [{ inventoryList }, { get_inventory_by_id, get_pricing_by_id }, { },] = useProductInventoryPriceStore();
  const { siteUser, systemModules: { CART }, siteUser: { CORE, WEB }, speedBoats: { apacAbbr, japanAbbr } } = Constants
  const { avUserInfoData: { speedBoatNameLower, currentUser, salesOrg } } = System
  const { translation: t } = System;
  const [isCartLoad, setIsCartLoad] = useState(false);

  const backordersObject = (v) => {
    let data = {}
    data = {
      "quantity": v.quantity,
      "ERPPartNumber": productList[v.itemNumber]?.ERPPartNumber,
      "ERPMFRPartNumber": productList[v.itemNumber]?.ERPMFRPartNumber,
      "ItemNumber": productList[v.itemNumber]?.ItemNumber,
      "ManufacturerPartNumber": productList[v.itemNumber]?.ManufacturerPartNumber,
      "ManufacturerName": productList[v.itemNumber]?.ManufacturerName,
      "FactoryLeadTime": productList[v.itemNumber]?.FactoryLeadTime,
      "ShortDescription": productList[v.itemNumber]?.ShortDescription,
      "cartId": v.cartId,
      "cartDetailId": v.cartDetailId,
      "totalQuantity": v.quantity,
      "backOrderedQuantity": v.quantity - get_inventory_by_id(v.itemNumber).totalInventory
    }
    return data
  }
  const [,{ get_quantity_format }] = useSystem();
  const isApacCoreAndJapanWeb = (System.getCurrentRegionWithType(apacAbbr, CORE) || System.getCurrentRegionWithType(japanAbbr, WEB))

  useEffect(() => {
    if (Object.entries(CART_DATA)?.length > 0 && Object.entries(productList)?.length > 0 && Object.entries(inventoryList)?.length > 0 && (System.getCurrentRegionWithType(apacAbbr, CORE) || System.getCurrentRegionWithType(japanAbbr, WEB))) {

      let backordered_cart_list = []
      Object.entries(CART_DATA).map(obj => {
        let productQty = get_inventory_by_id(obj[1]?.itemNumber)?.totalInventory
        const checkQuantity = obj[1].quantity > productQty

        if (isOpenedBackOrderPopup === false && checkQuantity === true && (obj[1].backOrderedQuantity === 0 || (obj[1].backOrderedQuantity !== (obj[1].quantity - productQty))) && !backorder_not_available(productList[obj[1].itemNumber]) && obj[1].isProductAvailableFromMainAPI !== false) {
          backordered_cart_list.push(backordersObject(obj[1]))
          setIsOpenedBackOrderPopup(true)
        }
      })

      if (!isOpenedBackOrderPopup && backordered_cart_list?.length > 0) {
        System.popup('InventoryAlertForAddToCartPopup', {
          single_product: backordered_cart_list,
          isFrom: Constants.systemModules.CART
        })
      }
    }

    if (firstServerCall) {
      setFirstServerCall(false);
    }
    if (!isCartLoad && CART_DATA && Object.keys(CART_DATA)?.length > 0 && Object.keys(productList)?.length > 0) {
      let cartProductArr = Object.keys(CART_DATA).map((x) => {
        return { ...CART_DATA[x], ERPSupplierCode: productList[x]?.ERPSupplierCode, qas: productList[x]?.Stock }
      })
      if (cartProductArr.length > 0) {
        HelperAnalyticsEvent.cartEvent({ productList: cartProductArr, eventName: 'cartView' });
      }
      setIsCartLoad(true)
    }
  }, [CART_DATA, productList, inventoryList])

  useEffect(() => {
    if (__check(['CART_API_CALL']).status) {
      setIsLoader(true)

    } else {
      setIsLoader(false)
    }
  }, [firstServerCall, __check(['CART_API_CALL']).status]);

  const checkBackorderInventory = (v) => {
    let productQty = get_inventory_by_id(v.ItemNumber)?.totalInventory
    return v.quantity - productQty > 0 ? true : false
  }

  return (
    <>
      {isLoader ? <AxiosIndicatorRunTimeLoader /> :
        <>
          {(Object.entries(CART_DATA).length === 0) ? (
            <>
              <FadeInOut show={true} duration={1000} className="cleared-cart-wrapper">
                <div className="center-link">
                  <a href={System.getHomepageUrl()} className="bs5 btn btn-primary w240 text-uppercase">
                    {t('continueShopping')}  </a>
                </div>
              </FadeInOut>
            </>
          ) :
            <div className="bs5 row">
              <div className="col-12">
                <div className="cart-list-table table-responsive">
                  <table className="table" >
                    <tbody>
                      {Object.entries(CART_DATA)?.length > 0 &&
                        Object.entries(CART_DATA).map((v, i) => (
                          <React.Fragment key={v[1].ItemNumber}>
                            <tr key={v[1].ItemNumber}
                              className={productList[v[1].ItemNumber] && productList[v[1].ItemNumber].NCNRFlag ? "ncnr" : "non-ncnr"} >
                              <td className="cart-list-product-img">
                                <div className="product-info nopadding">
                                  <span>{t('item')}: {i + 1}</span>
                                  <div className="product-img sect-1 text-center">
                                    <img alt="Product"
                                      src={v[1].assetURL ? v[1].assetURL : noImage} />
                                  </div>
                                  <div className="prod-option-icon sect-2 d-flex flex-wrap">
                                    <ProductLegends single_product={productList[v[1].ItemNumber]}
                                      onlyIcon={true} />
                                  </div>
                                </div>
                              </td>
                              <td className="cart-list-product-detail">
                                <div className="d-flex">
                                  <div className="product-detail">
                                    <div className={v[1]?.isProductAvailableFromMainAPI === false ? "product-name text-black mb-2" : "product-name mb-2"}>
                                      <div className="d-flex align-items-center">
                                        <span className="me-1">
                                          {(v[1].isProductAvailableFromMainAPI === false) ?
                                            v[1].ERPMFRPartNumber
                                            : (
                                              <NavigateToProductDetail
                                                data={{ ManufacturerName: v[1]?.manufacturerName, ERPMFRPartNumber: v[1]?.ERPMFRPartNumber, ItemNumber: v[1]?.ItemNumber, ERPPartNumber: v[1]?.ERPPartNumber, seoItemNumber: v[1]?.seoItemNumber }}>
                                                <strong>
                                                  {v[1].ERPMFRPartNumber}
                                                </strong>
                                              </NavigateToProductDetail>
                                            )}

                                        </span>
                                        <Tooltip
                                          className='carttooltip'
                                          position={'bottom center'}
                                          opener={() => <i className={'fa fa-exclamation-circle'} />}
                                          content={() => <>
                                            <div className="text-center">
                                              {productList[v[1].ItemNumber]?.ShortDescription?.substring(0, 100)}
                                            </div>
                                            <hr />

                                            <div className="text-center">ECCN: {productList[v[1].ItemNumber]?.ECCNCode}</div>
                                            <div className="text-center">Schedule B: {productList[v[1].ItemNumber]?.ScheduleBCode}</div>
                                            <div className="text-center">HTSN: {productList[v[1].ItemNumber]?.HTSCode}</div>
                                          </>}
                                        />
                                      </div>
                                      <div className="text-black-stone cursor-default">
                                        <div className="d-inline text-wrap w-auto">{t('by')}&nbsp;</div>
                                        <a
                                          href={`/${speedBoatNameLower}/manufacturers/m/${Helper.replaceSpecialChar(productList[v[1].ItemNumber]?.ManufacturerName?.toLowerCase())}`}
                                          className="text-blue text-break cursor-pointer"
                                          title={productList[v[1].ItemNumber]?.ManufacturerName}
                                        >
                                          {productList[v[1].ItemNumber]?.ManufacturerName}
                                        </a>
                                      </div>
                                    </div>
                                    {v[1]?.isProductAvailableFromMainAPI !== false && (
                                      <ProductInventoryDisplay single_product={productList[v[1].ItemNumber]}
                                        single_product_inventory={get_inventory_by_id(productList[v[1].ItemNumber]?.ItemNumber)}
                                        showDashedLine={false} imageShow={false} isFrom={Constants.systemModules.CART} />
                                    )}
                                  </div>


                                  {(CART_LOADER_DATA_OBJECT[v[1].ItemNumber]?.isUpdatingCpnType && __check(["CART_OPERATION_API_CALL"]).status) ? (
                                    <div className="price-table-list ms-auto">
                                      <AxiosIndicatorRunTimeLoader />
                                    </div>

                                  ) : (
                                    <>
                                      {v[1]?.isProductAvailableFromMainAPI !== false &&
                                        <div className="price-table-list ms-auto">
                                          {(System.checkIsCustomerPrice(get_pricing_by_id({ ItemNumber: v[1].ItemNumber }))) &&
                                            <div className="blue-head cpn-box">
                                              <span className="text-nowrap">{t('customerSpecificPricing')}</span>
                                              <span className="fa fa-handshake-o" />
                                            </div>
                                          }

                                          <div className="bs5 row">
                                            <div className="col-6">
                                              <span>{t('unitPrice')}:</span>
                                            </div>
                                            <div className="col-6 text-end font_bold_currency">
                                              <span>
                                                {System.getFormatNumber({ amount: Number(v[1].unitPrice), currency: System.getRegionCurrency() })}
                                              </span>
                                            </div>
                                          </div>

                                          <div className="bs5 row">
                                            <div className="col-6">
                                              <span>{t('subtotal')}:</span>
                                            </div>
                                            <div className="col-6 text-end font_bold_currency">
                                              <span>
                                                {isNumber(v[1].subtotal)
                                                  ? System.getFormatNumber({ amount: Number(v[1].subtotal), currency: System.getRegionCurrency()})
                                                  : ""}
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      }
                                    </>
                                  )}
                                </div>
                                {v[1]?.isProductAvailableFromMainAPI !== false &&
                                  <div className="d-flex justify-content-start part-info">
                                    <CustomerPartNumberOptions
                                    isFrom={Constants.systemModules.CART}
                                      single_product={productList[v[1].ItemNumber]}
                                      updationCompletedCallback={async (SELECTED_CUSTOMER_PART_NUMBER) => {
                                        let CPNValue = v[1].cpn
                                        if (CPNValue !== SELECTED_CUSTOMER_PART_NUMBER) {
                                          let param = {
                                            ...v[1],
                                            cartDetailId: v[1].cartDetailId,
                                            cpn: SELECTED_CUSTOMER_PART_NUMBER
                                            // endCustAccNum: get_end_customer_by_cpn(productList[v[1].ItemNumber].CustomerPartNumbers, SELECTED_CUSTOMER_PART_NUMBER)
                                          }
                                          await update_To_Cart_Server(param)
                                        }
                                      }}
                                      defaultValue={v[1].cpn}
                                      from={CART}
                                    />
                                    <div className="form-group">
                                      <label htmlFor="sel1">
                                        <b>{t('itemNoteLabel')}</b>
                                        <Tooltip position={"bottom"} content={() => t('itemNote')}
                                          opener={() => (
                                            <i className="fa fa-info-circle ms-1 font-13" />
                                          )} />
                                      </label>
                                      <div>
                                        <InputWithDebounce
                                          className="form-control"
                                          type="text"
                                          placeholder="ex. 4353ES"
                                          defaultValue={v[1].referencePartNumber}
                                          onChange={async (value) => {
                                            await update_To_Cart_Server({
                                              ...v[1],
                                              referencePartNumber: value
                                            })
                                          }}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                }


                              </td>
                              <td className="cart-list-product-update">
                                {v[1]?.isProductAvailableFromMainAPI !== false && productList[v[1].ItemNumber] && !isLoader &&
                                  <>
                                    <FadeInOut show={true} duration={250} >
                                      <div className="quantity clearfix">
                                        <QuantityPickerForUpdateCart
                                          single_product_inventory={get_inventory_by_id(v[1].ItemNumber)}
                                          single_product={productList[v[1].ItemNumber]}
                                          single_product_pricing_list={get_pricing_by_id({ ItemNumber: v[1].ItemNumber })}
                                          single_cart_data={v[1]}
                                          qp_unique_id={v[1].cartDetailId}
                                          isFrom={CART}
                                        />
                                      </div>
                                    </FadeInOut>
                                    <div className="p-15">
                                      <div className="text-start small-text light light-text collapse_minmax">
                                        <DisplayQtyMinQtyMult
                                          single_product={productList[v[1].ItemNumber]}
                                        />
                                      </div>
                                      {(v[1].quantity > get_inventory_by_id(v[1].ItemNumber).totalInventory) === true && (v[1].backOrderedQuantity === 0 || (v[1].backOrderedQuantity !== (v[1].quantity - get_inventory_by_id(v[1]?.itemNumber)?.totalInventory))) && !backorder_not_available(productList[v[1].ItemNumber]) && !System.getCurrentRegionWithType(Constants.speedBoats.apacAbbr, Constants.siteUser.WEB) && liveAuth.check() && (
                                        <>
                                          <a href={void 0} onClick={() => {
                                            System.popup('InventoryAlertForAddToCartPopup', {
                                              single_product: [backordersObject(v[1])],
                                              isFrom: Constants.systemModules.CART
                                            })
                                          }} > {" "} {t('backorderRemainingQuantity')} </a>
                                          <br />
                                        </>
                                      )}
                                      {/* {(currentUser === siteUser.CORE && !productList[v[1].ItemNumber].SoftwareDownloadFlag) ? ( */}
                                      {(currentUser === siteUser.CORE) ? (
                                        <QuantityScheduler
                                          CART_DATA_SINGLE={v[1]}
                                          single_product_inventory={get_inventory_by_id(v[1].ItemNumber)}
                                          CART_PRODUCT_DATA={productList[v[1].ItemNumber]}
                                        />) : ("")}

                                    </div>
                                    {(v[1].backOrderedQuantity && v[1].backOrderedQuantity > 0) ?
                                      (
                                        <div className="bs5 row">
                                          <div className="col-6">{t('available')}:</div>
                                          <div className="col-6 text-end">
                                            {get_quantity_format(get_inventory_by_id(v[1].ItemNumber)?.totalInventory)}
                                          </div>
                                        </div>
                                      ) : null}
                                    {v[1].backOrderedQuantity && v[1].backOrderedQuantity > 0 ? (
                                      <div className="bs5 row position-relative">
                                        <div className="col-6">
                                          <Beacon position={"left"} content={() => t('backorderPartsMessage')}
                                            opener={() => (
                                              <div className="becon-dot"></div>
                                            )} />{t('backordered')}:</div>
                                        <div className="col-6 text-end">{get_quantity_format(v[1].backOrderedQuantity)}</div>
                                      </div>
                                    ) : null}
                                  </>
                                }

                                {v[1]?.isProductAvailableFromMainAPI === false &&
                                  <ClearSingleCartProductFromCart currentCartItem={v[1]} cartType={CART} CART_PRODUCT_DATA={productList[v[1].ItemNumber]}>
                                    <button className="bs5 btn btn-secondary btn-sm ms-auto">
                                      {t('removeItemFromCart')}
                                    </button>
                                  </ClearSingleCartProductFromCart>
                                }
                              </td>
                              <td className="cart-list-close">
                                {(v[1].isProductAvailableFromMainAPI === false) &&
                                  <div className="alert alert-danger not-eligible-alert">
                                    <div className="bs5 w-100 d-flex justify-content-center">
                                      <span>
                                        {t('itemNoLongerAvailableInCart')}
                                      </span>
                                      <img className="ms-2" alt="Alert" src={yellowalert} />
                                    </div>
                                  </div>
                                }
                                <ClearSingleCartProductFromCart currentCartItem={v[1]} cartType={CART}
                                CART_PRODUCT_DATA={productList[v[1].ItemNumber]}>
                                  <div className="close-ic">
                                    <img src={closeic} alt="Close" />
                                  </div>
                                </ClearSingleCartProductFromCart>
                              </td>

                            </tr>
                            <tr>
                              <td className="cart-list-error"></td>
                              <td colSpan={3} className="cart-list-error">
                                {(isApacCoreAndJapanWeb && productList[v[1].ItemNumber] && productList[v[1].ItemNumber].ObsoleteFlag && checkBackorderInventory(v[1])) && (
                                  <div className="alert alert-danger not-eligible-alert">
                                    <div className="bs5 w-100 d-flex justify-content-center">
                                      <span>{t('unableToBackOrderObsoleteItem')}</span>
                                      <img className="ms-2" alt="Alert" src={yellowalert} />
                                    </div>
                                  </div>
                                )}

                                {(isApacCoreAndJapanWeb && productList[v[1].ItemNumber] && productList[v[1].ItemNumber].EndOfLifeFlag && checkBackorderInventory(v[1])) && (
                                  <div className="alert alert-danger not-eligible-alert">
                                    <div className="bs5 w-100 d-flex justify-content-center">
                                      <span>{t('unableToBackOrderEOLItem')}</span>
                                      <img className="ms-2" alt="Alert" src={yellowalert} />
                                    </div>
                                  </div>
                                )}
                                {(isApacCoreAndJapanWeb && productList[v[1].ItemNumber] && productList[v[1].ItemNumber]?.ExcessInventoryFlag && checkBackorderInventory(v[1])) && (
                                  <div className="alert alert-danger not-eligible-alert">
                                    <div className="bs5 w-100 d-flex justify-content-center">
                                      <span>{t('exceededStockForBackorder')}</span>
                                      <img className="ms-2" alt="Alert" src={yellowalert} />
                                    </div>
                                  </div>
                                )}

                                {(productList[v[1].ItemNumber] && productList[v[1].ItemNumber].NCNRFlag) && (
                                  <div className="alert alert-dark ncnr-alert justify-content-center">
                                    <b>NCNR:</b> <span>{t('nonCancelableNonReturnable')}</span>
                                  </div>
                                )}

                              </td>
                            </tr>
                          </React.Fragment>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          }
        </>
      }
    </>
  );
};

export default CartList;